// Value imports: a `import type` here would be erased at compilation, and the `registerStore` call
// bundled inside each store module would never run — the store would silently never register.
import accountFacilitiesStore from '@UI/Store/AccountFacilities';
import brandingStore from '@UI/Store/Branding';
import accountStore from '@UI/Store/Account';
import accountMetricsStore from '@UI/Store/AccountMetrics';
import indicatorsStore from '@UI/Store/Indicators';
import aiConfigurationStore from '@UI/Store/AiConfiguration';
import aiCostLimitAlertsStore from '@UI/Store/AiCostLimitAlerts';
import aiCostLimitsStore from '@UI/Store/AiCostLimits';
import aiCostsStore from '@UI/Store/AiCosts';
import aiModelFamiliesStore from '@UI/Store/AiModelFamilies';
import aiTranscriptionDeliveryModesStore from '@UI/Store/AiTranscriptionDeliveryModes';
import aiProviderKindsStore from '@UI/Store/AiProviderKinds';
import aiUsagesStore from '@UI/Store/AiUsages';
import auditActionsStore from '@UI/Store/AuditActions';
import auditOutcomesStore from '@UI/Store/AuditOutcomes';
import auditResourceTypesStore from '@UI/Store/AuditResourceTypes';
import auditTrailStore from '@UI/Store/AuditTrail';
import authenticatedUserStore from '@UI/Store/AuthenticatedUser';
import beneficiariesStore from '@UI/Store/Beneficiaries';
import beneficiaryContactsStore from '@UI/Store/BeneficiaryContacts';
import documentsStore from '@UI/Store/Documents';
import contactRelationshipsStore from '@UI/Store/ContactRelationships';
import contactRolesStore from '@UI/Store/ContactRoles';
import documentTemplateFilesStore from '@UI/Store/DocumentTemplateFiles';
import documentTemplatesStore from '@UI/Store/DocumentTemplates';
import documentTypesStore from '@UI/Store/DocumentTypes';
import facilitiesStore from '@UI/Store/Facilities';
import facilityUsersStore from '@UI/Store/FacilityUsers';
import facilityStatusesStore from '@UI/Store/FacilityStatuses';
import importedDocumentsStore from '@UI/Store/ImportedDocuments';
import interviewsStore from '@UI/Store/Interviews';
import organizationsStore from '@UI/Store/Organizations';
import organizationWorkflowsStore from '@UI/Store/OrganizationWorkflows';
import permissionCatalogStore from '@UI/Store/PermissionCatalog';
import facilityWorkflowsStore from '@UI/Store/FacilityWorkflows';
import workflowRunsStore from '@UI/Store/WorkflowRuns';
import recordingPolicyStore from '@UI/Store/RecordingPolicy';
import retentionSettingsStore from '@UI/Store/RetentionSettings';
import rolesStore from '@UI/Store/Roles';
import staffFunctionsStore from '@UI/Store/StaffFunctions';
import beneficiaryAccessStore from '@UI/Store/BeneficiaryAccess';
import staffMembersStore from '@UI/Store/StaffMembers';
import subjectsStore from '@UI/Store/Subjects';
import subjectTypeDefinitionsStore from '@UI/Store/SubjectTypeDefinitions';
import subjectTypesStore from '@UI/Store/SubjectTypes';
import templateFieldTypesStore from '@UI/Store/TemplateFieldTypes';
import userPermissionsStore from '@UI/Store/UserPermissions';
import userStatusesStore from '@UI/Store/UserStatuses';
import usersStore from '@UI/Store/Users';
import ssoStore from '@UI/Store/Sso';
import ssoModesStore from '@UI/Store/SsoModes';

const rootStore = {
	...auditTrailStore,
	...aiCostLimitAlertsStore,
	...aiCostLimitsStore,
	...aiCostsStore,
	...auditActionsStore,
	...auditOutcomesStore,
	...auditResourceTypesStore,
	...authenticatedUserStore,
	...beneficiariesStore,
	...beneficiaryContactsStore,
	...documentsStore,
	...userPermissionsStore,
	...facilitiesStore,
	...facilityUsersStore,
	...usersStore,
	...retentionSettingsStore,
	...rolesStore,
	...permissionCatalogStore,
	...facilityWorkflowsStore,
	...workflowRunsStore,
	...organizationsStore,
	...organizationWorkflowsStore,
	...accountFacilitiesStore,
	...brandingStore,
	...accountMetricsStore,
	...accountStore,
	...indicatorsStore,
	...userStatusesStore,
	...facilityStatusesStore,
	...ssoStore,
	...ssoModesStore,
	...staffMembersStore,
	...subjectsStore,
	...subjectTypesStore,
	...beneficiaryAccessStore,
	...subjectTypeDefinitionsStore,
	...staffFunctionsStore,
	...contactRolesStore,
	...contactRelationshipsStore,
	...documentTemplateFilesStore,
	...documentTemplatesStore,
	...documentTypesStore,
	...templateFieldTypesStore,
	...importedDocumentsStore,
	...interviewsStore,
	...recordingPolicyStore,
	...aiConfigurationStore,
	...aiUsagesStore,
	...aiProviderKindsStore,
	...aiModelFamiliesStore,
	...aiTranscriptionDeliveryModesStore,
};

export default rootStore;
